
import { ref } from 'vue';

interface Drop{
  text:string
}
export default {
  props:{
    onDropDown:{
      type:Function,
      default:()=>{
        return '+254'
      }
    }
  },
 setup(props:any,{emit}:any) {
    const showPopover = ref(false);

    // 通过 actions 属性来定义菜单选项
    const actions = [
      { text: '254' },
      { text: '256' },
      { text: '234' },
    ];
    let prefix = ref(common.getStorage('address')?common.getStorage('address').country_code: actions[0].text)
    const onSelect = (action:Drop) => {
      prefix.value = action.text
      emit('onDropDown',action.text)
    };

    return {
      actions,
      onSelect,
      showPopover,
      prefix
    };
  },
}
